<!--  -->
<template>
  <div class="aboutUsPage">
    <mainDetail :mainDetail="mainDetail" class="main">
      <el-image
        :src="require('../../assets/icon/aboutUsImg1.png')"
        class="aboutUsImg1"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/aboutUsImg2.png')"
        class="aboutUsImg2"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/aboutUsImg3.png')"
        class="aboutUsImg3"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/aboutUsImg4.png')"
        class="aboutUsImg4"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/aboutUsImg5.png')"
        class="aboutUsImg5"
      ></el-image>
    </mainDetail>
    <div class="aboutUs">
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="title">
            <span>关于我们</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="nav">
            <span>帝博值得您多了解一点</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="16">
          <el-row :gutter="30" class="aboutUsContent">
            <el-col :span="10">
              <el-image
                :src="require('../../assets/icon/diboImg.png')"
              ></el-image>
            </el-col>
            <el-col :span="14">
              <div class="text">
                <span>{{ aboutUsText }}</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="honor">
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="title">
            <span>荣誉资质</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="nav">
            <span>我们通过先进的自动化体系，已为众多行业领域赋能</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <ul class="honorContent">
            <li v-for="item in honorText" :key="item">
              <span>{{ item }}</span>
            </li>
          </ul>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="18" class="certificate">
          <el-image
            :src="require('../../assets/icon/certificate1.png')"
            class="certificate1"
          ></el-image>
          <el-image
            :src="require('../../assets/icon/certificate2.png')"
            class="certificate2"
          ></el-image>
          <el-image
            :src="require('../../assets/icon/certificate3.png')"
            class="certificate3"
          ></el-image>
          <el-image
            :src="require('../../assets/icon/certificate4.png')"
            class="certificate4"
          ></el-image>
          <el-image
            :src="require('../../assets/icon/certificate5.png')"
            class="certificate5"
          ></el-image>
          <el-image
            :src="require('../../assets/icon/certificate6.png')"
            class="certificate6"
          ></el-image>
        </el-col>
      </el-row>
      <el-image
        :src="require('../../assets/icon/background.svg')"
        class="backgroundImg"
      ></el-image>
    </div>
  </div>
</template>

<script>
import mainDetail from "@/components/main/main";

export default {
  components: {
    mainDetail
  },
  data() {
    return {
      aboutUsText:
        "我们是一家专注于信息技术自动化的高新技术企业，成立于2015年，位于苏州园区。我们具备十足的技术实力与创新活力，目前已拥有国家发明专利的软件开发平台（Diboot）及多项软件领域专利、软著等自主知识产权，并为多家客户打造了自主产权的软件系统。我们拥有技术精湛的研发团队，公司核心成员均来自IBM、三星、用友等国内外知名企业，核心成员均10年+软硬件架构与研发经验。自成立以来，一直秉承'技术创新，诚信务实'的发展理念，一步一个脚印，努力成为您落地新型信息化稳定可靠的IT合作伙伴。",
      honorText: [
        "国家高新技术企业",
        "江苏省软件企业、科技型中小企业",
        "4项国家发明专利",
        "18项软件著作权、软件产品证书"
      ],
      mainDetail: {
        h1: "靠谱+努力",
        lis: [
          "秉承“技术创新，诚信务实”的发展理念,",
          "脚踏实地，努力成为您落地新型信息化",
          "'靠谱+努力' 的IT合作伙伴"
        ],
        buttonText: "加入我们",
        buttonImg: require("../../assets/icon/computer.png"),
        mainImg: require("../../assets/icon/us.png"),
        isMarginTop: true
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped lang="less">
.aboutUsPage {
  background-color: #fafafb;
}
.main {
  position: relative;
  .aboutUsImg1 {
    position: absolute;
    top: 9%;
    right: 29%;
    width: 5%;
    z-index: 9;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .aboutUsImg2 {
    position: absolute;
    top: 43%;
    right: 4%;
    width: 37%;
    z-index: 97;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .aboutUsImg3 {
    position: absolute;
    top: 100%;
    right: 29%;
    width: 11%;
    z-index: 99;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .aboutUsImg4 {
    position: absolute;
    top: 96%;
    right: 14%;
    width: 11%;
    z-index: 99;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .aboutUsImg5 {
    position: absolute;
    top: 70%;
    right: 5%;
    width: 11%;
    z-index: 98;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
}
.title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 14px;
  span {
    background: linear-gradient(to right, #55baf7, #0fe50f);
    background-clip: text;
    color: transparent;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 170%;
      left: 50%;
      transform: translateX(-50%) skewX(30deg);
      width: 60px;
      height: 7px;
      background: linear-gradient(to right, #55baf7, #0fe50f);
      border-radius: 5px;
    }
  }
}
.nav {
  color: #55baf7;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  font-size: 18px;
}
.aboutUs {
  margin-bottom: 110px;
  margin-top: 50px;
  .text {
    line-height: 36px;
    font-size: 18px;
  }
  .aboutUsContent {
    display: flex;
    align-items: center;
  }
}
.honor {
  position: relative;
  .backgroundImg {
    position: absolute;
    width: 15%;
    left: 0;
    top: -5%;
  }
  .honorContent {
    font-size: 20px;
    text-align: center;
    margin-bottom: 50px;
    li {
      line-height: 38px;
      span {
        position: relative;
        &::before {
          content: "";
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #55bafa;
          position: absolute;
          left: -30px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &:nth-child(2n) {
        span {
          &::before {
            background-color: #77cf3e;
          }
        }
      }
    }
  }
  .certificate {
    position: relative;
    height: 700px;
    .certificate1 {
      position: absolute;
      width: 25%;
      top: 3%;
      left: 50%;
      transform: translateX(-150%);
      transition: all 0.6s;
      box-shadow: 0px 10px 15px 0px #eee;
      &:hover {
        z-index: 10;

        transform: translateX(-150%) scale(1.1);
        cursor: pointer;
      }
    }
    .certificate2 {
      position: absolute;
      width: 32%;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
      transition: all 0.6s;
      border: 3px solid #ccc;
      &:hover {
        z-index: 10;
        transform: translateX(-50%) scale(1.1);
        cursor: pointer;
      }
    }
    .certificate3 {
      position: absolute;
      width: 25%;
      top: 3%;
      left: 50%;
      transform: translateX(50%);
      transition: all 0.6s;
      box-shadow: 0px 10px 15px 0px #eee;
      &:hover {
        z-index: 10;
        transform: translateX(50%) scale(1.1);
        cursor: pointer;
      }
    }
    .certificate4 {
      position: absolute;
      width: 18%;
      top: 33%;
      left: 50%;
      transform: translateX(-150%);
      transition: all 0.6s;
      box-shadow: 0px 10px 15px 0px #eee;
      &:hover {
        z-index: 10;
        transform: translateX(-150%) scale(1.1);
        cursor: pointer;
      }
    }
    .certificate5 {
      position: absolute;
      width: 17%;
      top: 38%;
      left: 50%;
      transform: translateX(-50%);
      transition: all 0.6s;
      box-shadow: 0px 10px 15px 0px #eee;
      &:hover {
        z-index: 10;
        transform: translateX(-50%) scale(1.1);
        cursor: pointer;
      }
    }
    .certificate6 {
      position: absolute;
      width: 18%;
      top: 33%;
      left: 50%;
      transform: translateX(50%);
      transition: all 0.6s;
      box-shadow: 0px 10px 15px 0px #eee;
      &:hover {
        z-index: 10;
        transform: translateX(50%) scale(1.1);
        cursor: pointer;
      }
    }
  }
}
</style>
